export type MenuModel = AnyMenuItem[] | ((query: string) => AnyMenuItem[]);

export type AnyMenuItem =
  | ({ type: 'item' } & MenuItemProps)
  | { type: 'divider' }
  | ({ type: 'text' } & MenuTextProps)
  | ({ type: 'submenu' } & SubMenuItemProps);

export function menuItem(props: MenuItemProps) {
  return { type: 'item', ...props } satisfies AnyMenuItem;
}

export function subMenu(props: SubMenuItemProps) {
  return { type: 'submenu', ...props } satisfies AnyMenuItem;
}

export function menuDivider() {
  return { type: 'divider' } satisfies AnyMenuItem;
}

export function menuText(props: MenuTextProps) {
  return { type: 'text', ...props } satisfies AnyMenuItem;
}

export type MenuTextProps = {
  label: string;
  size?: 'tiny' | 'small';
};

export type MenuItemProps = {
  label: string;
  /**
   * If specified the item will have <label> . <sub label> with sub label being
   * grey.
   */
  subLabel?: string;
  labelCanWrap?: boolean;
  description?: string;
  searchSynonyms?: string;
  icon?: React.ComponentType | React.ReactNode;
  iconRight?: React.ComponentType | React.ReactNode;
  componentRight?:
    | React.ReactNode
    | ((args: { isHighlighted: boolean }) => React.ReactNode);
  shortcut?: string;
  checked?: boolean;
  disabled?: boolean;
  disabledReason?: string;
  subtlyDisabled?: boolean;
  hasSubmenuOpen?: boolean;
  tooltip?: string;
  onClick?(): void;
  closeOnClick?: boolean;
  onMouseEnter?(e: React.MouseEvent): void;
  onMouseLeave?(): void;
  onPointerDown?(e: React.PointerEvent): void;
  href?: string;
  target?: '_blank' | '_self';
};

export type SubMenuItemProps = Pick<
  MenuItemProps,
  'label' | 'icon' | 'disabled' | 'disabledReason'
> & {
  menu: MenuModel;
};
